<app-header sectionName="Stocks">
  <button mat-icon-button (click)="drawer.toggle()" [matTooltip]="drawer.opened ? 'Hide bot accounts' : 'Show bot accounts'">
    <mat-icon>{{ drawer.opened ? 'menu_open' : 'menu' }}</mat-icon>
  </button>
</app-header>

<mat-drawer-container class="main-container" autosize>
  <mat-drawer #drawer class="sidenav-left" [mode]="isMobile ? 'over' : 'side'" position="start">
    <app-account-list [type]="'stock'"></app-account-list>
  </mat-drawer>

  <div class="main-content">
    <div class="page">

      <!-- Status counts double as filter chips. Buttons, not spans, so they are
           reachable by keyboard and announced as controls. -->
      @if (counts) {
      <div class="status-chips" role="group" aria-label="Filter by status">
        <button type="button" class="status-chip status-all" [class.active]="filterStatus === ''"
          [attr.aria-pressed]="filterStatus === ''" (click)="filterStatus = ''; applyFilters()">
          All<b>{{ counts.total | number }}</b>
        </button>
        <button type="button" class="status-chip status-ready" [class.active]="filterStatus === 'Ready'"
          [attr.aria-pressed]="filterStatus === 'Ready'" (click)="filterStatus = 'Ready'; applyFilters()">
          Ready<b>{{ counts.ready | number }}</b>
        </button>
        <button type="button" class="status-chip status-transferring" [class.active]="filterStatus === 'Transferring'"
          [attr.aria-pressed]="filterStatus === 'Transferring'" (click)="filterStatus = 'Transferring'; applyFilters()">
          Transferring<b>{{ counts.transferring | number }}</b>
        </button>
        <button type="button" class="status-chip status-notready" [class.active]="filterStatus === 'NotReady'"
          [attr.aria-pressed]="filterStatus === 'NotReady'" (click)="filterStatus = 'NotReady'; applyFilters()">
          Not ready<b>{{ counts.not_ready | number }}</b>
        </button>
        <button type="button" class="status-chip status-done" [class.active]="filterStatus === 'Done'"
          [attr.aria-pressed]="filterStatus === 'Done'" (click)="filterStatus = 'Done'; applyFilters()">
          Done<b>{{ counts.done | number }}</b>
        </button>
        <button type="button" class="status-chip status-failed" [class.active]="filterStatus === 'Failed'"
          [attr.aria-pressed]="filterStatus === 'Failed'" (click)="filterStatus = 'Failed'; applyFilters()">
          Failed<b>{{ counts.failed | number }}</b>
        </button>
        <button type="button" class="status-chip status-archived" [class.active]="filterStatus === 'Archived'"
          [attr.aria-pressed]="filterStatus === 'Archived'" (click)="filterStatus = 'Archived'; applyFilters()">
          Archived<b>{{ counts.archived | number }}</b>
        </button>
      </div>
      }

      <div class="list-toolbar">
        <app-supplier-filter class="supplier-filter" [supplierId]="filterSupplierId"
          (supplierIdChange)="onSupplierChange($event)"></app-supplier-filter>

        <mat-form-field appearance="outline" class="filter" subscriptSizing="dynamic">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [(ngModel)]="search" (keyup.enter)="applyFilters()" placeholder="Account email or name">
          @if (search) {
          <button matSuffix mat-icon-button aria-label="Clear search" (click)="search = ''; applyFilters()">
            <mat-icon>close</mat-icon>
          </button>
          }
        </mat-form-field>

        <button mat-stroked-button (click)="applyFilters()">Apply</button>
        @if (filterStatus || filterSupplierId || search) {
        <button mat-button (click)="clearFilters()">
          <mat-icon>filter_alt_off</mat-icon> Clear filters
        </button>
        }

        <span class="spacer"></span>

        <button mat-icon-button aria-label="Reload" matTooltip="Reload" (click)="load()">
          <mat-icon [class.spinning]="loading">refresh</mat-icon>
        </button>
        @if (canEdit) {
        <button mat-flat-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Add account
        </button>
        }
      </div>

      <!-- Sticky: bulk readiness changes across hundreds of rows are the core
           interaction, and the bar scrolling away mid-selection loses it. -->
      @if (canEdit && selected.size > 0) {
      <div class="bulk-bar">
        <mat-icon>checklist</mat-icon>
        <span><b>{{ selected.size | number }}</b> selected</span>
        <span class="spacer"></span>
        <button mat-flat-button color="primary" (click)="arm()">
          <mat-icon>play_arrow</mat-icon> Mark ready
        </button>
        <button mat-stroked-button (click)="disarm()">
          <mat-icon>pause</mat-icon> Mark not ready
        </button>
        <button mat-stroked-button color="warn" (click)="remove()">
          <mat-icon>delete_outline</mat-icon> Delete
        </button>
        <button mat-button (click)="selected.clear()">Clear</button>
      </div>
      }

      <div class="table-card">
      @if (loading) {
      <div class="table-state"><mat-spinner diameter="32"></mat-spinner></div>
      } @else if (error) {
      <div class="table-state error">
        <mat-icon>error_outline</mat-icon>
        <p>{{ error }}</p>
        <button mat-stroked-button (click)="load()">Retry</button>
      </div>
      } @else if (stocks.length === 0) {
      <div class="table-state">
        <mat-icon>inbox</mat-icon>
        <p>No accounts match these filters.</p>
        @if (filterStatus || filterSupplierId || search) {
        <button mat-stroked-button (click)="clearFilters()">Clear filters</button>
        } @else if (canEdit) {
        <button mat-flat-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Add account
        </button>
        }
      </div>
      }

      <!-- Mobile: one card per account. Nine columns force sideways scrolling
           and push the actions menu off-screen. -->
      @else if (isMobile) {
      <div class="cards">
        <label class="select-all">
          <mat-checkbox [checked]="allSelected" (change)="toggleAll()"></mat-checkbox>
          Select all on this page
        </label>

        @for (s of stocks; track trackById($index, s)) {
        <div class="card" [class.selected]="selected.has(s.id)">
          <div class="card-head">
            <mat-checkbox [checked]="selected.has(s.id)" (change)="toggle(s.id)"></mat-checkbox>
            <span class="email">{{ s.login_info_email }}</span>
            <span class="pill" [ngClass]="statusClass(s.status)">{{ s.status }}</span>
            <button mat-icon-button [matMenuTriggerFor]="cardMenu" aria-label="Actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #cardMenu="matMenu">
              @if (canEdit) {
              @if (s.status !== 'Transferring' && s.status !== 'Ready') {
              <button mat-menu-item (click)="arm(s)"><mat-icon>play_arrow</mat-icon> Mark ready</button>
              } @else {
              <button mat-menu-item (click)="disarm(s)"><mat-icon>pause</mat-icon> Mark not ready</button>
              }
              }
              <button mat-menu-item (click)="viewRuns(s)"><mat-icon>history</mat-icon> Transfer history</button>
              @if (canEdit) {
              <button mat-menu-item (click)="edit(s)"><mat-icon>edit</mat-icon> Edit details</button>
              }
            </mat-menu>
          </div>

          <button type="button" class="supplier-link" (click)="openSupplierInfoDialog(s)">
            {{ s.supplier_name || s.supplier }}
          </button>

          <ng-container [ngTemplateOutlet]="notes" [ngTemplateOutletContext]="{ s: s }"></ng-container>

          <dl class="card-grid">
            <div>
              <dt>Balance</dt>
              <dd class="num">{{ s.remained_coins | number }}</dd>
            </div>
            <div>
              <dt>Spendable</dt>
              <dd class="num" [class.negative]="headroom(s) <= 0">{{ headroom(s) | number }}</dd>
            </div>
            <div>
              <dt>Stop threshold</dt>
              <dd class="num">{{ s.coins_to_be_remain | number }}</dd>
            </div>
          </dl>
          <div class="card-foot">Updated {{ s.updated_at | date:'short' }}</div>
        </div>
        }
      </div>
      }

      @else {
      <div class="table-scroll">
        <table mat-table [dataSource]="stocks" [trackBy]="trackById">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox [checked]="allSelected" (change)="toggleAll()"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let s">
              <mat-checkbox [checked]="selected.has(s.id)" (change)="toggle(s.id)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Account</th>
            <td mat-cell *matCellDef="let s">
              <div class="email">{{ s.login_info_email }}</div>
              @if (s.description) {
              <div class="sub">{{ s.description }}</div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="supplier">
            <th mat-header-cell *matHeaderCellDef>Supplier</th>
            <td mat-cell *matCellDef="let s">
              <button type="button" class="supplier-link" (click)="openSupplierInfoDialog(s)">
                {{ s.supplier_name || s.supplier }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let s">
              <span class="pill" [ngClass]="statusClass(s.status)">{{ s.status }}</span>
              <ng-container [ngTemplateOutlet]="notes" [ngTemplateOutletContext]="{ s: s }"></ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="remained">
            <th mat-header-cell *matHeaderCellDef class="num-col">Balance</th>
            <td mat-cell *matCellDef="let s" class="num-col num">{{ s.remained_coins | number }}</td>
          </ng-container>

          <ng-container matColumnDef="headroom">
            <th mat-header-cell *matHeaderCellDef class="num-col"
              matTooltip="Balance above the effective floor — what a run could actually spend.">
              Spendable
            </th>
            <td mat-cell *matCellDef="let s" class="num-col num" [class.negative]="headroom(s) <= 0">
              {{ headroom(s) | number }}
            </td>
          </ng-container>

          <ng-container matColumnDef="threshold">
            <th mat-header-cell *matHeaderCellDef class="num-col">Stop threshold</th>
            <td mat-cell *matCellDef="let s" class="num-col">
              <span class="num">{{ s.coins_to_be_remain | number }}</span>
              @if (s.floor_raised_by_minimum) {
              <div class="sub warn"
                matTooltip="The platform minimum credit is higher than the supplier's threshold, so the run stops earlier.">
                effective: {{ s.effective_floor | number }}
              </div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="updated">
            <th mat-header-cell *matHeaderCellDef>Updated</th>
            <td mat-cell *matCellDef="let s" class="muted"
              [matTooltip]="s.updated_at | date:'medium'">{{ s.updated_at | date:'short' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let s">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                @if (canEdit) {
                @if (s.status !== 'Transferring' && s.status !== 'Ready') {
                <button mat-menu-item (click)="arm(s)"><mat-icon>play_arrow</mat-icon> Mark ready</button>
                } @else {
                <button mat-menu-item (click)="disarm(s)"><mat-icon>pause</mat-icon> Mark not ready</button>
                }
                }
                <button mat-menu-item (click)="viewRuns(s)"><mat-icon>history</mat-icon> Transfer history</button>
                @if (canEdit) {
                <button mat-menu-item (click)="edit(s)"><mat-icon>edit</mat-icon> Edit details</button>
                }
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.row-selected]="selected.has(row.id)"></tr>
        </table>
      </div>
      }

      @if (!loading && !error && stocks.length > 0) {
      <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 100, 200]" (page)="onPage($event)">
      </mat-paginator>
      }
      </div>
    </div>
  </div>
</mat-drawer-container>

<!-- Everything worth saying about a row beyond its status, in one place so the
     table and the mobile cards cannot drift apart. -->
<ng-template #notes let-s="s">
  @if (s.disarm_requested_at) {
  <div class="sub warn">Stop requested — will halt at a safe boundary</div>
  }
  @if (problemLabel(s)) {
  <div class="sub" [ngClass]="problemClass(s)">{{ problemLabel(s) }}</div>
  }
  @if (s.fail_detail && problemLabel(s) !== s.fail_detail) {
  <div class="sub muted">{{ s.fail_detail }}</div>
  }
</ng-template>
